<template>
  <div class="home">
    <!-- Not logged → show login form -->
    <LogIn v-if="!isLogged" />
  </div>
</template>

<script>
// English-only comments
import LogIn from '@/views/LogIn.vue';

export default {
  name: 'HomeView',

  components: {
    LogIn,
  },

  computed: {
    isLogged() {
      return this.$store.getters.isLogged;
    },
  },

  created() {
    // If user is already logged in, redirect to dashboard
    if (this.isLogged) {
      this.$router.replace('/dashboard');
    }
  },

  watch: {
    // React if login happens while staying on HomeView
    isLogged(newVal) {
      if (newVal) {
        this.$router.replace('/dashboard');
      }
    },
  },
};
</script>

<style scoped>
.home {
  min-height: 100vh;
}
</style>
